import style from '../style-edit-resources';
import { backgroundStyles } from '../compound-settings';

const getHeadingModules = (heading) => {
    return [
        {
            template: 'FontSelection',
            modules: [
                `heading/${heading}/style/fontFamily`,
                `heading/${heading}/style/fontWeight`,
            ],
        },
        {
            path: `heading/${heading}/style/fontSize`,
            content: {
                ...style.fontSize,
            },
        },
        {
            hoverable: false,
            isResponsible: true,
            template: 'FontSpaceLH',
            label: 'Spacing & Line Height',
            modules: [
                {
                    path: `heading/${heading}/style/lineHeight`,
                    content: {
                        ...style.lineHeight,
                    },
                },
                {
                    path: `heading/${heading}/style/letterSpacing`,
                    content: style.letterSpacing,
                },
            ],
        },
        { path: `heading/${heading}/style/color`, content: style.color },
    ];
};

export default {
    default: [
        {
            hoverControl: false,
            label: 'Body Background',
            modules: ['settings/activeBgStyle', ...backgroundStyles],
        },
        {
            hoverControl: false,
            label: 'Body / Paragraph Typography',
            modules: [
                {
                    template: 'FontSelection',
                    modules: ['style/fontFamily', 'style/fontWeight'],
                },
                {
                    path: 'style/fontSize',
                    content: { isResponsible: true, defaultValue: '16px' },
                },
                {
                    hoverable: false,
                    isResponsible: true,
                    template: 'FontSpaceLH',
                    label: 'Spacing & Line Height',
                    modules: [
                        {
                            path: 'style/lineHeight',
                            content: { defaultValue: '24px' },
                        },
                        'style/letterSpacing',
                    ],
                },
                'style/color',
            ],
        },
        {
            hoverControl: false,
            label: 'Heading Typography',
            modules: [
                {
                    path: 'settings/activeHeading',
                    content: {
                        template: 'Tab',
                        inputType: 'boxed',
                        defaultValue: 'h1',
                        options: [
                            { label: 'H1', value: 'h1' },
                            { label: 'H2', value: 'h2' },
                            { label: 'H3', value: 'h3' },
                            { label: 'H4', value: 'h4' },
                            { label: 'H5', value: 'h5' },
                            { label: 'H6', value: 'h6' },
                        ],
                    },
                },
                {
                    conditions: [
                        ['settings/activeHeading', '===', 'h1'],
                        '||',
                        ['settings/activeHeading', '===', undefined],
                    ],
                    modules: getHeadingModules('h1'),
                },
                {
                    conditions: ['settings/activeHeading', '===', 'h2'],
                    modules: getHeadingModules('h2'),
                },
                {
                    conditions: ['settings/activeHeading', '===', 'h3'],
                    modules: getHeadingModules('h3'),
                },
                {
                    conditions: ['settings/activeHeading', '===', 'h4'],
                    modules: getHeadingModules('h4'),
                },
                {
                    conditions: ['settings/activeHeading', '===', 'h5'],
                    modules: getHeadingModules('h5'),
                },
                {
                    conditions: ['settings/activeHeading', '===', 'h6'],
                    modules: getHeadingModules('h6'),
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Container & Column',
            modules: [
                {
                    path: 'settings/containerWidth',
                    content: {
                        min: 0,
                        max: 5000,
                        defaultUnit: 'px',
                        template: 'Range',
                        defaultValue: '1140px',
                        label: 'Container Width',
                    },
                },
                {
                    path: 'settings/columnGap',
                    content: {
                        min: 0,
                        max: 150,
                        defaultUnit: 'px',
                        template: 'Range',
                        defaultValue: '30px',
                        label: 'Default Column Gap',
                    },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Link Style',
            modules: [
                {
                    path: 'tags/a/style/color',
                    content: {
                        template: 'ColorPicker',
                        label: 'Color',
                    },
                },
                {
                    path: 'tags/a/style/_textDecoration',
                    content: {
                        onLabel: 'ON',
                        offLabel: 'OFF',
                        offValue: 'none',
                        label: 'Underline',
                        template: 'Switch',
                        onValue: 'underline',
                        defaultValue: 'underline',
                    },
                },
            ],
        },
    ],
};
